import { useState, useEffect, useCallback } from 'react';

const useTabVisibility = (onTabVisible?: () => void): boolean => {
  const [isActive, setIsActive] = useState<boolean>(() => {
    if (typeof document === 'undefined') {
      return true;
    }
    return document.visibilityState === 'visible';
  });

  const memoizedOnTabVisible = useCallback(() => {
    if (onTabVisible) {
      onTabVisible();
    }
  }, [onTabVisible]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const isCurrentlyActive = document.visibilityState === 'visible';

      setIsActive(isCurrentlyActive);

      if (isCurrentlyActive) {
        memoizedOnTabVisible();
      }
    };

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      }
    };
  }, [memoizedOnTabVisible]);

  return isActive;
};

export default useTabVisibility;
